"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _angieslistAppPlatform = require("angieslist-app-platform");

var _Badge2 = _interopRequireDefault(require("angieslist-react-components/lib/Badge"));

require("./officeHeader.scss");

var _headerAnalytics = _interopRequireDefault(require("./headerAnalytics"));

var _Badge;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var activityLocation = function activityLocation(isAngiLeads) {
  return isAngiLeads ? 'Leads Auth Header' : 'Ads Auth Header';
};

var OfficeNav = function OfficeNav(_ref) {
  var angiLeadsProperties = _ref.angiLeadsProperties,
      leadsNotificationCount = _ref.leadsNotificationCount,
      reviewsNotificationCount = _ref.reviewsNotificationCount,
      spId = _ref.spId,
      toggleHeaderSubNav = _ref.toggleHeaderSubNav,
      currentSubNav = _ref.currentSubNav,
      isInboxEnabled = _ref.isInboxEnabled,
      messagesNotificationCount = _ref.messagesNotificationCount,
      isAngiLeadsAdmin = _ref.isAngiLeadsAdmin;

  var _useState = (0, _react.useState)(currentSubNav),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
      originalSubNav = _useState2[0];

  return [/*#__PURE__*/_react["default"].createElement("small", {
    className: "hidden-xs hidden-sm",
    key: "unified-header-left-nav--leads",
    onMouseEnter: function onMouseEnter() {
      return toggleHeaderSubNav(true, 'leads');
    }
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    className: "unified-header-nav-item".concat(originalSubNav === 'leads' ? '--selected-nav-item' : '', " unified-header-left-nav-item\n              ").concat(currentSubNav === 'leads' ? 'unified-header-nav-item--hover-nav-item' : ''),
    "data-track-activity-location": activityLocation(angiLeadsProperties.isAngiLeads),
    "data-track-description": "Leads",
    "data-intercom-target": "Leads",
    id: "unified-header-left-nav--leads",
    href: angiLeadsProperties.isAngiLeads ? _urlCatalog["default"].office.leads.leadsBoard(spId) : _urlCatalog["default"].office.ads.leadBoard(spId)
  }, "Leads")), leadsNotificationCount && leadsNotificationCount > 0 ? /*#__PURE__*/_react["default"].createElement(_Badge2["default"], {
    bsStyle: "danger"
  }, leadsNotificationCount) : null), angiLeadsProperties.isAngiLeads && angiLeadsProperties.showOpportunityLeadsNavLink && isAngiLeadsAdmin ? /*#__PURE__*/_react["default"].createElement("small", {
    className: "hidden-xs hidden-sm",
    key: "unified-header-left-nav--opportunities",
    onMouseEnter: function onMouseEnter() {
      return toggleHeaderSubNav(true, 'opportunities');
    }
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    className: "unified-header-nav-item".concat(originalSubNav === 'opportunities' ? '--selected-nav-item' : '', " unified-header-left-nav-item\n              ").concat(currentSubNav === 'opportunities' ? 'unified-header-nav-item--hover-nav-item' : ''),
    "data-track-activity-location": activityLocation(angiLeadsProperties.isAngiLeads),
    "data-track-description": "Opportunities",
    "data-intercom-target": "Opportunities",
    id: "unified-header-left-nav--opportunities",
    href: _urlCatalog["default"].office.leads.opportunities(spId)
  }, "Opportunities")), angiLeadsProperties.hasOpportunityNotifications ? _Badge || (_Badge = /*#__PURE__*/_react["default"].createElement(_Badge2["default"], {
    bsStyle: "danger"
  })) : null) : undefined, /*#__PURE__*/_react["default"].createElement("small", {
    className: "hidden-xs hidden-sm",
    key: "unified-header-left-nav--reviews",
    onMouseEnter: function onMouseEnter() {
      return toggleHeaderSubNav(true, 'reviews');
    }
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    className: "unified-header-nav-item".concat(originalSubNav === 'reviews' ? '--selected-nav-item' : '', " unified-header-left-nav-item\n              ").concat(currentSubNav === 'reviews' ? 'unified-header-nav-item--hover-nav-item' : ''),
    "data-track-activity-location": activityLocation(angiLeadsProperties.isAngiLeads),
    "data-track-description": "Reviews",
    "data-intercom-target": "Reviews",
    id: "unified-header-left-nav--reviews",
    href: angiLeadsProperties.isAngiLeads ? _urlCatalog["default"].office.leads.reviews(spId) : _urlCatalog["default"].office.ads.reviews(spId)
  }, "Reviews")), reviewsNotificationCount && reviewsNotificationCount > 0 ? /*#__PURE__*/_react["default"].createElement(_Badge2["default"], {
    bsStyle: "danger"
  }, reviewsNotificationCount) : null), /*#__PURE__*/_react["default"].createElement("small", {
    className: "hidden-xs hidden-sm",
    key: "unified-header-left-nav--my-business",
    onMouseEnter: function onMouseEnter() {
      return toggleHeaderSubNav(true, 'myBusiness');
    }
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    className: "unified-header-nav-item".concat(originalSubNav === 'myBusiness' ? '--selected-nav-item' : '', " unified-header-left-nav-item\n              ").concat(currentSubNav === 'myBusiness' ? 'unified-header-nav-item--hover-nav-item' : ''),
    "data-track-activity-location": activityLocation(angiLeadsProperties.isAngiLeads),
    "data-track-description": "My business",
    "data-intercom-target": "My business",
    id: "unified-header-left-nav--my-business",
    href: angiLeadsProperties.isAngiLeads ? _urlCatalog["default"].office.leads.businessSettings(spId) : _urlCatalog["default"].office.ads.spProfile.edit(spId)
  }, "My business"))), !angiLeadsProperties.isAngiLeads || isInboxEnabled ? /*#__PURE__*/_react["default"].createElement("small", {
    className: "hidden-xs hidden-sm",
    key: "unified-header-left-nav--messages",
    onMouseEnter: function onMouseEnter() {
      return toggleHeaderSubNav(true, 'messages');
    }
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement("a", {
    className: "unified-header-nav-item".concat(originalSubNav === 'messages' ? '--selected-nav-item' : '', " unified-header-left-nav-item\n            ").concat(currentSubNav === 'messages' ? 'unified-header-nav-item--hover-nav-item' : ''),
    "data-track-activity-location": activityLocation(angiLeadsProperties.isAngiLeads),
    "data-track-description": "Messages",
    "data-intercom-target": "Messages",
    id: "unified-header-left-nav--messages",
    href: angiLeadsProperties.isAngiLeads ? _urlCatalog["default"].office.leads.inbox(spId) : _urlCatalog["default"].office.inbox(spId)
  }, "Messages")), messagesNotificationCount && messagesNotificationCount > 0 ? /*#__PURE__*/_react["default"].createElement(_Badge2["default"], {
    bsStyle: "danger"
  }, messagesNotificationCount) : null) : undefined];
};

var _default = (0, _angieslistAppPlatform.analytics)({
  ruleset: _headerAnalytics["default"]
})(OfficeNav);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/header/officeNav.js
// module id = 3656
// module chunks = 25